module.exports = "/cyber/_next/static/images/other-places-prize-bb0aef706b506d7bcf3183e5b97cfb51.png";